import { createContext, useContext, useState } from 'react';

const SubscriptionsContext = createContext();

export const SubscriptionsProvider = ({ children }) => {
  const [data, setData] = useState([
    {
        id: "stop-smoking",
        roles: [
            {
                id: "role0",
                name: "Free Plan",
                description: "Capture ideas and feel the vibe",
                features: [
                    "Completely free",
                    "No credit card required",
                    "10 free messages per day",
                    "1 image per day",
                    "Ads integrated"
                ],
                price: 0,
            },
            {
                id: "role1",
                name: "Premium Plan",
                description: "Maximize your potential",
                features: [
                    "Unlimited messaging",
                    "Send unlimited images",
                    "No ads",
                    "Cancel any time"
                ],
                old_price: 9.99,
                price: 4.99,
                price_text: 'First month 50% off!',
                free_trial_days: 3,
                coupon: process.env.REACT_APP_COUPON,
                price_id: process.env.REACT_APP_SPID_STOPSMOKING_TIER1,
                isHighlighted: true
            }
        ],
    },
    {
        id: "healthy-diet",
        roles: [
            {
                id: "role0",
                name: "Free Plan",
                description: "Capture ideas and feel the vibe",
                features: [
                    "Completely free",
                    "No credit card required",
                    "10 free messages per day",
                    "1 image per day",
                    "Ads integrated"
                ],
                price: 0,
            },
            {
                id: "role1",
                name: "Premium Plan",
                description: "Maximize your potential",
                features: [
                    "Unlimited messaging",
                    "Send unlimited images",
                    "No ads",
                    "Cancel any time"
                ],
                old_price: 9.99,
                price: 4.99,
                price_text: 'First month 50% off!',
                free_trial_days: 3,
                coupon: process.env.REACT_APP_COUPON,
                price_id: process.env.REACT_APP_SPID_HEALTHYDIET_TIER1,
                isHighlighted: true
            }
        ]
    }
  ]);

  return (
    <SubscriptionsContext.Provider value={{ data, setData }}>
      {children}
    </SubscriptionsContext.Provider>
  )
}

export const useData = () => useContext(SubscriptionsContext);